import { Pipe, PipeTransform } from '@angular/core';
import {
	formatNumber,
	parseNumber,
	isValidNumber,
	ParsedNumber,
} from 'libphonenumber-js';

@Pipe({
	name: 'phone',
})
export class PhonePipe implements PipeTransform {
	transform(value: string): string {
		if (!value) {
			return value;
		}
		if (!isValidNumber(value, 'US')) {
			return value;
		}
		const parsedNumber = parseNumber(value, 'US') as ParsedNumber;
		return formatNumber(parsedNumber, 'National');
	}
}
